<template>
  <div>
    <div class="request-button" @click="isOpenModal = true">
      <img src="@/assets/icons/information.svg" />
    </div>
    <BaseModal class="request-modal" v-model="isOpenModal">
      <div class="form-content" v-if="!loading">
        <h2>Request to be improved or added</h2>
        <div v-if="alert != ''" class="message-box warning">{{ alert }}</div>
        <p>Please add here any feature you need to be developed</p>
        <select
          class="regular clear"
          name="priority"
          id="priority"
          v-model="priority"
        >
          <option value="">Select the level of priority</option>
          <option value="High">High</option>
          <option value="regular">Regular</option>
          <option value="Low">Low</option>
        </select>
        <br />
        <label for="title">What is your request about?</label>
        <br />
        <input
          class="regular clear"
          type="text"
          name="title"
          v-model="title"
          placeholder="Request title"
        />
        <br />
        <br />
        <textarea
          class="regular clear"
          name="moreInfo"
          id="moreInfo"
          cols="30"
          rows="5"
          placeholder="Add more info yo your request"
          v-model="moreInfo"
        />
        <br />
        <button
          id="upload-btn"
          class="btn-dark-button"
          @click="submitRequest()"
        >
          Submit Request
        </button>
      </div>
      <div v-else>
        <BaseSmallSpinner />
      </div>
    </BaseModal>
  </div>
</template>
<script>
import { sendImproveRequest } from "@/api/masterAdmin/MainAdminApi.js";

export default {
  data() {
    return {
      isOpenModal: false,
      priority: "",
      title: "",
      moreInfo: "",
      loading: false,
      alert: ""
    };
  },
  methods: {
    submitRequest() {
      this.loading = true;
      this.alert = "";
      if (this.title != "" && this.priority != "" && this.moreInfo != "") {
        let params = {
          priority: this.priority,
          title: this.title,
          moreInfo: this.moreInfo
        };
        sendImproveRequest(params)
          .then(() => {
            this.priority = "";
            this.moreInfo = "";
            this.title = "";
            this.$toast.open({
              message: `Thanks for your help. Request Saved`,
              type: "success",
              position: "top-right"
            });
          })
          .catch(() => {
            this.$toast.open({
              message: `Error Saving Request`,
              type: "error",
              position: "top-right"
            });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.alert = "Please fill the form";
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.loading-full {
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.request-modal {
  &.modal {
    .modal-content {
      height: 300px;
      width: 400px;
      padding: 0px;
    }
  }
}
.request-button {
  position: absolute;
  height: 40px;
  width: 40px;
  bottom: 200px;
  right: 0px;
  background-color: #eab800;
  display: flex;
  border-radius: 5px 0px 0px 5px;
  img {
    width: 80%;
    margin: auto;
  }
}
.form-content {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
